/* Preview stub — generated for the KCC branding live-preview lift of Studies + TopNavbar.
   No backend in this app; these inert modules satisfy the lifted components' imports. */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
 "autosaveStatus": "",
 "selectedReport": null,
 "reportsSearchText": "",
 "reportsSelectedCollaborators": [],
 "selectedReportsPageTab": "",
 "selectedReportsPageView": "",
 "reportsReferenceDrawerVisibility": "drawer-hidden"
};

const sliceObj = createSlice({
	name: "reports",
	initialState,
	reducers: {
		resetSelectedReportState: (_state, _action: PayloadAction<any>) => {},
		setAutosaveStatus: (_state, _action: PayloadAction<any>) => {},
		setReportsSearchText: (_state, _action: PayloadAction<any>) => {},
		setReportsSelectedCollaborators: (_state, _action: PayloadAction<any>) => {},
		setSelectedReport: (_state, _action: PayloadAction<any>) => {},
		setSelectedReportsPageTab: (_state, _action: PayloadAction<any>) => {},
		setSelectedReportsPageView: (_state, _action: PayloadAction<any>) => {},
		// Referenced by the Ask Kural ReferenceDrawer (report citations). Inert here —
		// the preview never opens the report reference drawer.
		setReportsReferenceDrawerVisibility: (state, action: PayloadAction<any>) => {
			state.reportsReferenceDrawerVisibility = action.payload;
		},
	},
});

export const { resetSelectedReportState, setAutosaveStatus, setReportsSearchText, setReportsSelectedCollaborators, setSelectedReport, setSelectedReportsPageTab, setSelectedReportsPageView, setReportsReferenceDrawerVisibility } = sliceObj.actions;
export default sliceObj.reducer;
